import { FC } from 'react'
import RightRobotCard from './common/RightRobotCard'
import useWindowSize from 'components/util/useWindowSize'

type Props = {}
const PostroomReinventedCard: FC<Props> = ({}) => {
  const size = useWindowSize()

  return (
    <RightRobotCard
      image={{
        alt: 'Scattered envelopes small cropped',
        desktop: {
          dimensions: {
            height: 393,
            width: 397,
          },
          src: '/images/new/scattared-envelops-cropped-small.png',
        },
        mobile: {
          dimensions: {
            height: 1024,
            width: 683,
          },
          src: '/images/new/scattared-envelops.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '44%' : '100%'}
      imageStyle={{
        height: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        objectPosition: 'left',
      }}
    >
      <div className='d-flex m fw-semibold flex-1 flex-column px-4 pt-8 pe-lg-0 ps-lg-20 py-lg-9'>
        <h2 className='lh-105 fw-semibold mb-6 fs-fluid-40-80'>
          The <span className='color-pink2'>ultimate SaaS solution</span> for
          efficient mail &amp; document management
        </h2>
        <h3 className='fs-fluid-18-24 mb-2 fw-bold'>
          <span className='color-pink2'>1 million+ pieces of mail</span>{' '}
          processed…and counting.
        </h3>
        <div className='d-flex flex-column lh-140 fs-fluid-18-20'>
          How do we process over a million pieces of mail with speed and
          precision? By combining enterprise-grade scanning with custom-built
          automation, we've transformed the way mail is handled—eliminating
          manual steps and ensuring accuracy at scale. <br />
          <br />
          Our intelligent system, powered by machine learning, doesn't just scan
          mail—it understands it. From sorting and categorising to fraud
          detection and compliance checks, every piece of mail is processed in
          real-time, seamlessly integrated with IBML Fusion scanners for a fully
          optimised workflow.
          <br />
          <br />
          By rethinking traditional mail processing, we've built an
          industry-leading system that delivers efficiency, security, and
          automation - helping businesses manage their post with zero friction.
        </div>
      </div>
    </RightRobotCard>
  )
}

export default PostroomReinventedCard
